import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-camera-retro-icon"
};
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  stroke: "none"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M18.125 1.25H10.5901C10.202 1.25 9.81926 1.34031 9.47211 1.51391L7.5 2.5H1.875C0.839453 2.5 0 3.33945 0 4.375V6.25H20V3.125C20 2.08945 19.1605 1.25 18.125 1.25ZM10 8.75C8.27766 8.75 6.875 10.1527 6.875 11.875C6.875 13.5973 8.27766 15 10 15C11.7223 15 13.125 13.5973 13.125 11.875C13.125 10.1527 11.7223 8.75 10 8.75Z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", { d: "M6.25 1.875C6.25 1.52977 5.97016 1.25 5.625 1.25H3.125C2.77984 1.25 2.5 1.52977 2.5 1.875V2.5H6.25V1.875ZM0 6.25V16.875C0 17.9105 0.839453 18.75 1.875 18.75H18.125C19.1605 18.75 20 17.9105 20 16.875V6.25H0ZM10 16.25C7.58879 16.25 5.625 14.2862 5.625 11.875C5.625 9.46371 7.58879 7.5 10 7.5C12.4112 7.5 14.375 9.46371 14.375 11.875C14.375 14.2862 12.4112 16.25 10 16.25Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitCameraRetroIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitCameraRetroIcon as default
};
//# sourceMappingURL=uikit-camera-retro-icon.vue.es.js.map
